import React, { Component } from 'react';

import IconWrap from './IconWrap';
import DevStatus from './DevStatus';

class ProjectInfo extends Component {

  constructor(props) {
    super(props);
    this.project = props.project;
  }

  render() {
    return (
      <div className="project-info">
        <span className="info-heading">{this.project.title}{this.project.year ? ` (${this.project.year})` : ``}</span>
        {(this.project.repo_url || this.project.site_url) && (
          <span className="info-links">
            {this.project.repo_url && <a className="icon-link" href={this.project.repo_url} target="_blank" title="Github repo"><img alt="Github repo" src="./icon/fa/brand/git-square.svg" /></a>}
            {this.project.site_url && <a className="icon-link" href={this.project.site_url} target="_blank" title="Website link"><img alt="Website link" src="./icon/fa/reg/extlink3.svg" /></a>}
          </span>
        )}
        {this.project.status && <span className="info-status"><DevStatus status={this.project.status}></DevStatus></span>}
        <div className="info-description" dangerouslySetInnerHTML={{__html: this.project.description}}></div>
        {this.project.tech.length > 0 && (
          <div className={this.project.tech.length > 1 ? "info-tech" : "info-tech info-tech-single"}>
            {this.project.tech.map((tech, idx) =>
              <IconWrap icon={tech} key={idx} showIcon={true} showTitle={true} />
            )}
          </div>
        )}
      </div>
    );
  }

}

export default ProjectInfo;



// WEBPACK FOOTER //
// ./src/components/ProjectInfo.js